<template>
  <div
    align="center"
    style="
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
    "
  >
    <transition name="fade">
      <a
        target="_blank"
        :href="getUrl(slides[counter].srcAlbum)"
        v-if="slides.length > 0 && slides[counter].show"
      >
        <img :src="slides[counter].src" alt="" 
            style='width: 100%; max-width:1000px; max-heigth: 288px' />
      </a>
    </transition>

    <p
      id="legend"
      style="
        text-decoration: none;
        font-size: 8px;
        color: #4069a6;
        line-height: 1.9;
      "
    >
      Legende: AK = Alpinkettern, BS = Bergsteigen, EK = Eisklettern, HT =
      Hochtour, KS = Klettersteig, MB = MountainBike, SK = Sportklettern, ST =
      Skitour, W = Wanderung, KT = Kinder/Kraxen-Tour, UR = Urlaub
    </p>

    <div align="left">
      <template v-for="album in albums">
        <span v-if="album.isSectionTitle" v-bind:key="album.title">
          <br />{{ album.section }}
        </span>
        <template v-else>
          &nbsp;&nbsp;&nbsp;&nbsp;<a
            :href="getUrl(album.url)"
            target="_blank"
            v-bind:key="album.title"
          >
            {{ album.title }}</a
          >
        </template>

        <br v-bind:key="album.url" />
      </template>
    </div>

  </div>
</template>
<script>
import { getToc } from "./UtilsAlbum.js";
import { startsWith } from "./Utils.js";

export default {
  name: "Main",
  mounted: function () {},
  props: {
    baseUrl: String,
  },
  data() {
    return {
      // random
      slides: [],
      counter: 0,
      // title, isSectionTitle, section, link, imageLink
      albums: [],
    };
  },
  async created() {
    var toc = await getToc(this.baseUrl);
    this.slides = toc.slides;
    this.albums = toc.albums;

    setInterval(
      function () {
        this.slideshow();
      }.bind(this),
      5000
    );
  },

  methods: {
    getUrl: function (albumUrl) {
      if (albumUrl) {
        if (startsWith(albumUrl, "http")) {
          return albumUrl;
        } else {
          return "?url=" + albumUrl;
        }
      }
    },
    slideshow: function () {
      this.slides[this.counter].show = false;
      this.counter =
        this.counter >= this.slides.length - 1 ? 0 : this.counter + 1;
      this.slides[this.counter].show = true;
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>